var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media)?_c('img',_vm._g(_vm._b({attrs:{"src":_vm.src}},'img',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }